/* unplugin-vue-components disabled */import { render } from "./PayBalanceConfirm.vue?vue&type=template&id=c2b25e18"
import script from "./PayBalanceConfirm.vue?vue&type=script&lang=js"
export * from "./PayBalanceConfirm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__